import React from 'react'
import cl from 'classnames'
import { SectionContainer } from '../../../components/shared'
import styles from './ViewersStats.module.scss'
import { observer } from 'mobx-react-lite'
import { STATISTICS_VIEWER_STORE } from '../../../store'
import { inject } from 'mobx-react'
import { SectionHeader } from '../common/SectionHeader'
import { ViewersExpandableSection } from './ViewersExpandableSection'
import { ViewersTable } from './ViewersTable/ViewersTable'
import { ViewersPeriodChart } from './ViewersPeriodChart'
import { ViewerStatsProps } from './ViewerStats.types'
import { IconViewers } from 'assets'

const ViewersStatsComponent = (props: ViewerStatsProps) => {
  const {
    [STATISTICS_VIEWER_STORE]: {
      onCustomPeriodSelect,
      onPeriodFilterSelect,
      customPeriod,
      periodFilter
    },
    className,
    style,
    renderDashboardVersion
  } = props

  return (
    <SectionContainer
      className={cl(styles.unsetPosition, className)}
      style={style}
    >
      <SectionHeader
        label={renderDashboardVersion ? 'Viewers statistics' : 'Viewers'}
        boldLabel={renderDashboardVersion}
        labelIcon={renderDashboardVersion && IconViewers}
        onPeriodFilterSelect={onPeriodFilterSelect}
        period={customPeriod}
        periodFilter={periodFilter}
        setPeriod={onCustomPeriodSelect}
      />
      <ViewersExpandableSection
        initialIsExpandedState={renderDashboardVersion}
        style={{ marginTop: '20px' }}
      />

      {!renderDashboardVersion && (
        <>
          <ViewersTable />
          <ViewersPeriodChart />
        </>
      )}

    </SectionContainer>
  )
}

const ViewersStats = inject(
  STATISTICS_VIEWER_STORE)(observer(ViewersStatsComponent))
export { ViewersStats }
